import { render, staticRenderFns } from "./AdminCloseAccountDialog.vue?vue&type=template&id=54f76ea1&scoped=true"
import script from "./AdminCloseAccountDialog.vue?vue&type=script&lang=js"
export * from "./AdminCloseAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f76ea1",
  null
  
)

export default component.exports